import FollowButton from "./follow-button";

export default FollowButton;